import { SET_VERSION, CLEAR_VERSION } from '../actions/logActions';

const initVersion = {
  value: null,
};

const versionLogReducer = (state = initVersion, action) => {
  const { type, payload } = action;

  switch (type) {
    case SET_VERSION:
      return {
        ...state,
        value: payload,
      };
    case CLEAR_VERSION:
      return { value: null };
    default:
      return state;
  }
};

export default versionLogReducer;
